import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import { useState } from 'react'
import styled from 'styled-components'

import { userSessionsAtom } from '@root/entities/auth'
import { SessionListItem } from '@root/entities/auth/ui/desktop'
import { SessionCard } from '@root/entities/auth/ui/mobile'
import { useBreakpoint } from '@root/shared'
import { FadeOverflow } from '@root/shared/ui-kit'

import { DeleteSessionDrawer } from '../mobile'

import { DeleteSessionDialog } from './delete-session-dialog'

import type { Session } from '@root/entities/auth'
import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps

export const SettingsSessionManagement: React.FC<Props> = ({ className }) => {
  const breakpoint = useBreakpoint()
  const [sessions] = useAtom(userSessionsAtom)
  const [sessionToDelete, setSessionToDelete] = useState<
    Session.Session | undefined
  >(undefined)

  const [SessionItemCmp, SessionConfirmCmp] =
    breakpoint === 'mobile'
      ? [SessionCard, DeleteSessionDrawer]
      : [SessionListItem, DeleteSessionDialog]

  return (
    <Root className={className}>
      <Content variant="vertical" mode="always">
        <List>
          {sessions.map((session: Session.Session) => (
            <SessionItemCmp
              key={session.ip}
              sessionInfo={session}
              onDelete={setSessionToDelete}
            />
          ))}
        </List>
      </Content>
      <AnimatePresence>
        {sessionToDelete ? (
          <SessionConfirmCmp
            session={sessionToDelete}
            open
            onOpenChange={(open) => {
              if (!open) {
                setSessionToDelete(undefined)
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  overflow: auto;
  /* max-height: 60vh; */
`

const Content = styled(FadeOverflow)`
  overflow: auto;
`

const List = styled.div`
  display: grid;
  align-content: start;
  grid-template-columns: auto;
  gap: 6px;

  padding-block: 16px var(--safe-bottom);
  padding-inline: 14px;
`
